import $ from "jquery";

export const lineupToc = () => {
  const mediaQuery = window.matchMedia("(max-width: 768px)");
  const $elem = $(".js-lineup-toc-title");
  const $parent = $(".js-lineup-section");

  // lineup-tocがないページでは早期リターン
  if ($parent.length === 0) {
    return;
  }

  // 親要素の上端位置を取得（ドキュメント内での位置）
  const parentTop = $parent.offset().top;
  const range = 200; // 200pxのスクロール範囲で補間

  function updateTransform() {
    const windowScroll = $(window).scrollTop();
    // 親要素内での相対スクロール量を算出
    const parentScroll = windowScroll - parentTop;

    let progress = parentScroll / range;
    progress = Math.max(0, Math.min(1, progress)); // 0～1にクランプ

    // scale: 1 → 0.68、translateY: 0px → 50px に線形補間
    const scale = 1 - 0.32 * progress;
    const translateY = 50 * progress;

    $elem.css("transform", `scale(${scale}) translateY(${translateY}px)`);
  }

  const updateBehavior = (mq) => {
    if (mq.matches) {
      // 768px以下の場合はスクロールイベントを解除して初期状態に戻す
      $(window).off("scroll", updateTransform);
      $elem.css("transform", "");
    } else {
      // 768pxを超える場合はスクロールイベントを登録
      $(window).off("scroll", updateTransform);
      $(window).on("scroll", updateTransform);
      updateTransform();
    }
  };

  // 初期状態の更新
  updateBehavior(mediaQuery);
  // メディアクエリの状態が変化したら更新
  mediaQuery.addEventListener("change", updateBehavior);
};
